export default class ContrastV2 {
	constructor() {
		this.minValue = -1;
		this.maxValue = 1;
		this.blockName = "ContrastV2";
		this.defaultContrast = 0;
		this.defaultPivot = 0.435;
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find(".contrast_slider")
			.on("input", _ => this.contrastSliderHandler($(element)));
		$(element)
			.find(".contrast_range")
			.on("change", _ => this.contrastValueHandler($(element)));

		$(element)
			.find(".pivot_slider")
			.on("input", _ => this.pivotSliderHandler($(element)));
		$(element)
			.find(".pivot_range")
			.on("change", _ => this.pivotValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: this.blockName,
			version: '2',
			passes: [this.addContrastPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				contrast: this.defaultContrast,
				pivot: this.defaultPivot
			},
		});
	}

	addContrastPass() {
		let shaderPass = gpu.createLiftGammaGainPass();
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	contrastSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let contrastValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, contrastValue);

		let block = lutify.getActiveBlock();
		block.values.contrast = contrastValue;
		block.passes[0].uniforms.contrast.value = contrastValue;
		gpu.render();
	}

	contrastValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let contrastValue = UI.getAdjustmentBlock_rangeValue($el);

		if (contrastValue > this.maxValue) {
			contrastValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, contrastValue);
		}
		if (contrastValue < this.minValue) {
			contrastValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, contrastValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, contrastValue);
		lutify.getActiveBlock().values.contrast = contrastValue;
		lutify.getActiveBlock().passes[0].uniforms.contrast.value = contrastValue;
		gpu.render();
	}

	pivotSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let pivotValue = UI.getAdjustmentBlock_sliderValue($el, 1);
		UI.setAdjustmentBlock_rangeValue($el, pivotValue, 1);

		let block = lutify.getActiveBlock();
		block.values.pivot = pivotValue;
		block.passes[0].uniforms.pivot.value = pivotValue;
		gpu.render();
	}

	pivotValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let pivotValue = UI.getAdjustmentBlock_rangeValue($el, 1);

		if (pivotValue > this.maxValue) {
			pivotValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, pivotValue, 1);
		}
		if (pivotValue < this.minValue) {
			pivotValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, pivotValue, 1);
		}

		UI.setAdjustmentBlock_sliderValue($el, pivotValue, 1);
		lutify.getActiveBlock().values.pivot = pivotValue;
		lutify.getActiveBlock().passes[0].uniforms.pivot.value = pivotValue;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		UI.setAdjustmentBlock_rangeValue($block, values.contrast, 0);
		UI.setAdjustmentBlock_rangeValue($block, values.pivot, 1);
		$block.find(".contrast_range").trigger("change");
		$block.find(".pivot_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
